module.exports = __webpack_public_path__ + "img/ledgercitygame-dot-com.f411ac28.png";